// extracted by mini-css-extract-plugin
module.exports = {"repeatLots":"4"};